module.exports = __webpack_public_path__ + "static/images/cover_A3.4a7855c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_A3.png
// module id = iug4
// module chunks = 8